import React, { useEffect, useState } from 'react';
import { Platform, ScrollView, View, } from 'react-native';
import { ColorTokens } from "@voltmoney/schema";
import ThemeProvider from "@voltmoney/theme";
import { isAndroid, isFromiOSBrowser, isIos } from '../utils';
const BoilerPlate = (props) => {
    const { height, children, bottomChildren, headerChild, paddingBottom, paddingTop, backgroundColor = ColorTokens.White, heightHeader = 0, scrollEnabled = true, alignContentCenter = false, ...restOfProps } = props;
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [headerHeight, setHeaderHeight] = useState(heightHeader);
    const [footerHeight, setFooterHeight] = useState(0);
    const [_height, setHeight] = useState(height);
    useEffect(() => {
        setHeight(height - headerHeight - footerHeight);
    }, [
        headerHeight,
        footerHeight
    ]);
    return (React.createElement(View, null,
        React.createElement(View, { style: {
                position: 'absolute',
                top: 0,
                width: '100%'
            }, onLayout: (event) => {
                setHeaderHeight(event?.nativeEvent?.layout?.height);
            } }, headerChild &&
            headerChild),
        React.createElement(ScrollView, { scrollEnabled: scrollEnabled, contentContainerStyle: alignContentCenter ? { flexGrow: 1, justifyContent: 'center' } : {}, keyboardShouldPersistTaps: isFromiOSBrowser() || isIos() || isAndroid() ? 'handled' : 'never', style: {
                height: _height,
                marginBottom: footerHeight ? footerHeight : 0,
                marginTop: headerHeight ? headerHeight : 0,
                backgroundColor: colorMapping[backgroundColor]
            } }, children),
        bottomChildren &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: Platform.OS === 'ios' ? 20 : 0,
                    width: '100%'
                }, onLayout: (event) => {
                    setFooterHeight(event?.nativeEvent?.layout?.height);
                } }, bottomChildren)));
};
export default BoilerPlate;
